/**
 * Afsluitregel als knop — op verzoek van Sjoerd (13 sep 2026).
 *
 * D8/§5 vroeg alleen een regel die naar de knop wijst, geen eigen knop.
 * Maar `.mv-closer` oogt zoals hij is opgemaakt (achtergrond, gecentreerd,
 * vetgedrukt) onmiskenbaar als knop, en de tekst zelf zegt "Jetzt in den
 * Warenkorb" — dus hij moet ook doen wat hij belooft.
 *
 * Geen eigen postlogica: dit klikt gewoon de echte bestelknop aan, met
 * welke variant/aantal daar al staat. Zo blijft er precies één plek die
 * bepaalt wat "in de winkelwagen" betekent.
 */
function vind_bestelknop(vanaf) {
  const scope = vanaf.closest('main') || document;
  return scope.querySelector('[id^="BuyButtons-ProductSubmitButton-"]');
}

function activeer(event) {
  const knop = vind_bestelknop(event.currentTarget);
  if (knop && !knop.disabled) knop.click();
}

function toets(event) {
  if (event.key !== 'Enter' && event.key !== ' ') return;
  event.preventDefault();
  activeer(event);
}

function koppel() {
  document.querySelectorAll('[data-mv-closer]').forEach((el) => {
    if (el.dataset.mvCloserBound) return;
    el.dataset.mvCloserBound = 'true';
    el.addEventListener('click', activeer);
    el.addEventListener('keydown', toets);
  });
}

koppel();
// Theme-editor: blok kan opnieuw gerenderd worden zonder page reload.
document.addEventListener('shopify:section:load', koppel);
document.addEventListener('shopify:block:select', koppel);
